"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_COLOR = exports.ICON_SIZE = exports.BREADCRUMB_TYPE_ICONS = exports.TARGET = exports.TEXT_TYPE = void 0;
var TEXT_TYPE = {
  active: {
    type: 'default',
    size: 'XSmall',
    color: 'nuetral'
  },
  disabled: {
    type: 'small',
    size: 'XSmall',
    color: 'greyDark'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var TARGET = {
  TAB: 'tab',
  SELF: 'self'
};
exports.TARGET = TARGET;
var BREADCRUMB_TYPE_ICONS = {
  '': '',
  CHEVRON_RIGHT: 'ChevronRightIcon'
};
exports.BREADCRUMB_TYPE_ICONS = BREADCRUMB_TYPE_ICONS;
var ICON_SIZE = 'titleNormal';
exports.ICON_SIZE = ICON_SIZE;
var ICON_COLOR = 'greyDark';
exports.ICON_COLOR = ICON_COLOR;